module.exports = __webpack_public_path__ + "img/193.8cede615.jpg";